import * as statuses from "../../constants/invoiceStatuses";

function isAllSelected(invoices, selectedInvoices) {
  return (
    invoices.filter(i => i.status === statuses.UNPAID && i.type !== "statement").length === selectedInvoices.length &&
    selectedInvoices.length !== 0
  );
}

export { isAllSelected };
